var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskDone01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.5C13.5 20.5 14.5 20.5 15.5 22.5C15.5 22.5 18.6765 17.5 21.5 16.5",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5H11M7 11.5H15",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4C4.9442 4.04667 4.01661 4.21984 3.37477 4.86227C2.49609 5.74177 2.49609 7.1573 2.49609 9.98836V16.4944C2.49609 19.3255 2.49609 20.741 3.37477 21.6205C4.25345 22.5 5.66767 22.5 8.49609 22.5H10.9961M15.4922 4C17.048 4.04667 17.9756 4.21984 18.6174 4.86228C19.4961 5.74177 19.4961 7.1573 19.4961 9.98836V14",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49609 4.25C6.49609 3.2835 7.2796 2.5 8.24609 2.5H13.7461C14.7126 2.5 15.4961 3.2835 15.4961 4.25C15.4961 5.2165 14.7126 6 13.7461 6H8.24609C7.2796 6 6.49609 5.2165 6.49609 4.25Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDone01);
export default __webpack_public_path__ + "static/media/task-done-01.746055d444943509a8aeefaccbbc7a95.svg";
export { ForwardRef as ReactComponent };